<template>
  <router-view></router-view>
</template>

<style lang="less" scoped>

</style>
<script type='es6'>
  export default{
    name: 'empty'
  }
</script>



// WEBPACK FOOTER //
// empty.vue?6aec5ee1